import {Controller} from "@hotwired/stimulus"

// DDT-4309 — AB test: « Contacter cet avocat » button on the premium cards of the desktop left column.
// Mounted on BE only (template-parts/premium_column.php); moved from FR so it never overlaps DDT-4322.
export default class extends Controller {
    static targets = [
        "card",
        "button",
    ]

    connect() {
        // Sessions that never see the column must not enter the test. Its wrapper is
        // d-none d-lg-block, and the theme's lg is 1280px, not Bootstrap's 992px:
        // check the rendered column rather than repeat the breakpoint here.
        if (!this.hasCardTarget || null === this.element.offsetParent) {
            return;
        }

        const premiumColumnContactAbTest = {
            id: 'ddt4309',
            action: 'ddt4309',
            sample: 100,
            params: {
                premium_lids: this.cardTargets.map(card => card.dataset.lid).join(','),
            },
            variants: [
                {
                    id: 'original',
                    weight: 50,
                    activate: () => {
                    },
                },
                {
                    id: 'variant',
                    weight: 50,
                    activate: () => {
                        this.buttonTargets.forEach(button => {
                            button.classList.replace('d-none', 'd-block');
                        });
                    },
                },
            ],
        };

        window.ddAbTest.enableExperiment(premiumColumnContactAbTest);
    }

    trackContactClick() {
        dataLayer.push({
            event: "dataLayer.gaEvent",
            gaEvent: {
                category: "listing results",
                action: "premium_card_contact_click",
                label: "-",
            },
        });
    }
}
